<div class="auth login d-flex">
  <div class="container">
    <div class="row justify-content-center align-items-center">
      <div class="col-12 col-sm-10 col-md-8 col-lg-6 col-xl-5">

        <div class="login-content">
          <mat-card appearance="outlined" class="p-5 mb-5 text-center">
            <div class="login-card-logo text-center">
              <img src="/assets/img/dx-kulture-logo.svg" alt="DX Kulture" width="160"/>
            </div>
            <mat-card-title class="mb-4 pb-3 text-center">
              <strong>Redirecting to secure login&hellip;</strong>
            </mat-card-title>
            <mat-card-content>
              <mat-spinner class="mx-auto" diameter="40"></mat-spinner>
            </mat-card-content>
          </mat-card>

          <div class="text-center sign-out-prompt">
            <span class="sign-out-prompt__question">Stuck on a verification step?</span>
            <button type="button" class="sign-out-prompt__link" (click)="signOut()">Sign Out and try a different account</button>
          </div>

        </div>

      </div>
    </div>

    @if (version$ | async; as v) {
      <div class="app-version-footer">
        v.{{ v.version }}
      </div>
    }
  </div>
</div>
